/**
 * Generated bundle index. Do not edit.
 */

export * from './index';

export {WithLoadingPipe as ɵa} from './src/pipes/with-loading-pipe';